(() => {
  'use strict';
  function updateAvailability(event) {
    document.querySelectorAll('[data-br22-availability]').forEach(root => {
      const data = JSON.parse(root.querySelector('[data-br22-variants]').textContent);
      if (event?.data?.sectionId && String(event.data.sectionId) !== String(data.section)) return;
      const variantId = event?.data?.variant?.id || root.closest('product-info')?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
      const variant = data.variants.find(v => String(v.id) === String(variantId));
      if (variant) root.querySelector('[data-br22-unavailable]').hidden = variant.available;
    });
  }
  document.addEventListener('change', () => requestAnimationFrame(() => updateAvailability()));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, updateAvailability);
})();
